import { render, staticRenderFns } from "./BlockList.vue?vue&type=template&id=62aec47a&scoped=true"
import script from "./BlockList.vue?vue&type=script&lang=js"
export * from "./BlockList.vue?vue&type=script&lang=js"
import style0 from "./BlockList.vue?vue&type=style&index=0&id=62aec47a&prod&scoped=true&lang=css"
import style1 from "./BlockList.vue?vue&type=style&index=1&id=62aec47a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aec47a",
  null
  
)

export default component.exports